@if (!reviewModalOpen()) {
  <div class="modal-body">
    @if (isInProgress() || isCompleted()) {
      <qai-loading size="extraSmall" [label]="currentStageLabel()" />
      @if (isTakingLonger()) {
        <qai-alert kind="processing" [title]="'simulationBuilder.STILL_PROCESSING_TITLE' | transloco">
          {{ 'simulationBuilder.STILL_PROCESSING_BODY' | transloco }}
        </qai-alert>
      } @else {
        <p class="supporting-text">{{ 'simulationBuilder.PROCESSING_DOCUMENTS_SUPPORTING_TEXT' | transloco }}</p>
      }
    }
    @if (isFailed()) {
      <qai-alert kind="error" [title]="'simulationBuilder.PROCESSING_FAILED_TITLE' | transloco">
        {{ 'simulationBuilder.PROCESSING_FAILED_BODY' | transloco }}
        <a class="failed-help-link" href="mailto:help@quantified.ai">help@quantified.ai</a>
        {{ 'simulationBuilder.PROCESSING_FAILED_SUFFIX' | transloco }}
      </qai-alert>
    }
    @if (isTokenLimitExceeded()) {
      <qai-alert kind="error" [title]="'simulationBuilder.PROCESSING_FAILED_TITLE' | transloco">
        {{ 'simulationBuilder.TOKEN_LIMIT_EXCEEDED_BODY_PREFIX' | transloco }}
        <a class="failed-help-link" href="mailto:help@quantified.ai">help@quantified.ai</a>
        {{ 'simulationBuilder.TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX' | transloco }}
      </qai-alert>
    }
  </div>

  <div class="action-button-container">
    @if (isFailed()) {
      <button qai-button size="medium" kind="secondary" [disabled]="retryInProgress()" (click)="handleRetryClick()">
        {{ 'simulationBuilder.BUTTON_RETRY' | transloco }}
      </button>
    }
    @if (isTokenLimitExceeded()) {
      <button qai-button size="medium" kind="secondary" (click)="handleBackWithPrefillClick()">
        {{ 'simulationBuilder.BUTTON_BACK' | transloco }}
      </button>
    }
  </div>
}

<generated-simulation-details-modal
  [open]="reviewModalOpen()"
  [callUuid]="callUuid() ?? ''"
  [moduleUuid]="moduleUuid() ?? ''"
  (closed)="handleReviewModalClosed()"
  (selectAvatarClicked)="handleSelectAvatarClick()"
></generated-simulation-details-modal>

<avatar-selection-modal
  [open]="avatarSelectionModalOpen()"
  [title]="'simulationBuilder.AVATAR_SELECTION_TITLE' | transloco"
  [form]="callPersonaForm()"
  [callUuid]="callUuid() ?? ''"
  [moduleUuid]="moduleUuid() ?? ''"
  (backToSimulationDetails)="handleBackToSimulationDetails()"
  (dismissed)="handleAvatarSelectionDismissed()"
></avatar-selection-modal>
